import { Box, Paper, Typography } from "@mui/material";

const NoAccessPage = () => {
  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 96px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 560,
          width: "100%",
          p: 4,
          borderRadius: 1,
          border: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.paper",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5 }}>
          Sin accesos habilitados
        </Typography>
        <Typography sx={{ color: "text.secondary" }}>
          Tu usuario no tiene integraciones asignadas para ver módulos en este
          dashboard. Pídele a un administrador que habilite los accesos que
          necesitas.
        </Typography>
      </Paper>
    </Box>
  );
};

export default NoAccessPage;
